import React from 'react';

import { PaperProps } from '@mui/material';

export const ALLOW_BUTTON = {
    ALL: 'all',
    SUBMIT: 'submit',
    CANCEL: 'cancel'
} as const;

export interface ModalProps {
    title: string;
    isModalOpen: boolean;
    isDisabledSubmitBtn?: boolean;
    children: React.ReactNode;
    submitBtnLabel: string;
    displayBtn?: 'all' | 'submit' | 'cancel';
    onCancel?: () => void;
    onSubmit: () => void;
    className?: string;
    dialogActionsButton?: React.ReactNode;
    paperProps?: Partial<PaperProps>;
}
